(function () {
    'use strict';

    let module = angular.module('imApp');

    module.factory('projectProcessService', [
        '$ihttp',
        function ($ihttp) {
            let service = {
                getEdit: function (parms) {
                    return $ihttp.post({
                        method: 908,
                        parameters: parms || {},
                    });
                },
                listPriceMethods: function (parms) {
                    return $ihttp.post({
                        method: 2203,
                        parameters: parms || {},
                    });
                },
                saveObj: async function (edit) {
                    return (
                        await $ihttp.post({
                            method: 1015,
                            parameters: edit,
                        })
                    )[0];
                },
                deleteItem: async function (edit) {
                    return (
                        await $ihttp.post({
                            method: 1016,
                            parameters: edit,
                        })
                    )[0];
                },
            };

            return service;
        },
    ]);
})();
